import React from 'react'

export const PagoExitoso = () => {
    const handleEnviarMarga = () => {
        window.location.replace("https://estanciamargarita.com.ar/auth/profile");
    }
  return (
    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0 bg-green-500/90">
       
        <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-green-100 sm:mx-0 sm:size-10">
                ✅
              </div>
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3 className="text-base text-2xl font-semibold text-gray-900 font-bebas" id="dialog-title">Pago Exitoso!</h3>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">Su pago ha sido efectuado con Exito!✨🥳 Sera redigirido a Mis Reservas.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
            <button type="button" onClick={()=> handleEnviarMarga()} className="inline-flex w-full justify-center rounded-md bg-sky-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-sky-500 sm:ml-3 sm:w-auto">Continuar.</button>
            
          </div>
        </div>
      </div>
      </div>
  )
}
export default PagoExitoso;
